// extracted by mini-css-extract-plugin
module.exports = {"canvas_size_w_min":"800"};